export default class Wpcf7SubmitBtnHandler {
  constructor() {
    this.init();
  }

  init() {
    const formSubmitBtns = $('.wpcf7-submit-custom');
    const wpcf7Elm = $('.wpcf7');

    formSubmitBtns.each((idx, el) => {
      let formId = $(el).parent().data('form-id');
      let thisContactForm = $('form#contact_form_' + formId);

      $(el).on('click', () => {
        thisContactForm.on('submit', () => {
          $(el).attr('disabled', '');
          if (formId == 519) {
            $(el).html('Subscribing...');
          }
          $(el).html('Submitting...');
        });

        wpcf7Elm.on('wpcf7submit', () => {
          // console.log('on SUBMIT!');
          $(el).removeAttr('disabled', '');
          if (formId == 519) {
            $(el).html('Subscribe');
          } else {
            $(el).html('Submit');
          }
        });

        wpcf7Elm.on('wpcf7mailsent', (event) => {
          const custom_redirect_url = event.detail?.inputs?.find(input => input.name === 'redirect_url')?.value;
          const thankyou_page = event.detail?.inputs?.find(input => input.name === 'thankyou_page')?.value;
          const widget_id = event.detail?.inputs?.find(input => input.name === 'widget_id')?.value || '';
          const postIDWhereFrom = $(event.currentTarget)
            .find('input[name="post-id"]')
            .val();

          // From Contact Form > Additional Settings > Redirect URL
          if (custom_redirect_url) {
            const custom_redirect_target = event.detail?.inputs?.find(input => input.name === 'redirect_target');

            if (custom_redirect_target) {
              window.open(`${custom_redirect_url}?referrer-post-id=${postIDWhereFrom}` + (widget_id ? `&wid=${widget_id}` : ''));
            } else {
              window.location.href = `${custom_redirect_url}?referrer-post-id=${postIDWhereFrom}` + (widget_id ? `&wid=${widget_id}` : ''); // eslint-disable-line
            }
            return true;
          }

          // From Contact Form > Additional Settings > Thank You Page
          if ($(el).closest('.has-thankyou-page').length && thankyou_page) {  // eslint-disable-line
            window.location.href = `${thankyou_page}?referrer-post-id=${postIDWhereFrom}` + (widget_id ? `&wid=${widget_id}` : ''); // eslint-disable-line
            return true;
          } 

          // From Site Options > Others > Contact Form Thank You Page
          if ($(el).closest('.has-thankyou-page').length && cf7_thank_you_page !== undefined && !widget_id) {  // eslint-disable-line
            window.location.href = cf7_thank_you_page.post_permalink; // eslint-disable-line
            return true;
          }

          //flysheet form section
          if (flysheet_pdfs_data !== undefined) { // eslint-disable-line
            if (flysheet_pdfs_data.flysheet_form_id == formId) { // eslint-disable-line
              window.location.href = `${flysheet_pdfs_data.post_permalink}?referrer-post-id=${postIDWhereFrom}` + (widget_id ? `&wid=${widget_id}` : ''); // eslint-disable-line
              return true;
            }
          }
        });
      });
    });
  }
}
